module.exports = __webpack_public_path__ + "static/media/16.f6d3edcf.jpg";